// extracted by mini-css-extract-plugin
module.exports = {"root":"IntegrationsCard_root__J-diE","item":"IntegrationsCard_item__1Svpw","text":"IntegrationsCard_text__1DpKj","statusName":"IntegrationsCard_statusName__1WW63"};